<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input v-model="model.name" />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Kochava_Field_Platform')"
        prop="params.platform"
      >
        <enum-select
          v-model="model.params.platform"
          :options="PlatformTypes"
          :disabled="!!model.id"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_Kochava_Field_ApiKey')"
        prop="params.api_key"
      >
        <el-input v-model="model.params.api_key" />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Kochava_Field_AppGuid')"
        prop="params.app_guid"
      >
        <el-input v-model="model.params.app_guid" />
      </rest-form-item>

      <rest-form-item
        prop="params.disable_event_forwarding"
        :hint="$t('Integrations_Kochava_Field_DisableEventForwading_Hint')"
      >
        <el-switch
          v-model="model.params.disable_event_forwarding"
          :active-text="$t('Integrations_Kochava_Field_DisableEventForwading')"
        />
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import EnumSelect from '@/common/components/form/EnumSelect'
import { PlatformTypes } from '@/modules/integrations/types/kochava/KochavaPlatformEnum'

export default {
  name: 'KochavaSettings',

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  components: {
    FormSection,
    RestFormItem,
    EnumSelect
  },

  data() {
    return {
      PlatformTypes
    }
  },

  computed: {
    rules() {
      return {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          platform: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          api_key: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          app_guid: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/kochava/KochavaSettings.vue